export default "__VITE_ASSET__DHneKQ5f__"